import React from 'react';
import ProductTag from '@conversion/components/ProductTag';

export const tagManager = ({ beforePriceTags, id, campaignTags }) => {
  let tags = beforePriceTags ? (
    <ProductTag key={id} tag={Object.assign({}, beforePriceTags[0])} />
  ) : null;
  if (!tags) {
    tags =
      campaignTags?.length > 0 &&
      campaignTags.map(c => <ProductTag key={id} tag={c} />);
  }
  return tags;
};
